<template>
  <header class="TheHeader">
    <div class="TheHeader-ContentWrapper">
      <router-link
        :to="{ name: 'home' }"
        class="TheHeader-LogoWrapper"
        exact
      >
        <img
          class="TheHeader-Logo"
          src="/img/logo_novo.png"
          alt="Logo da CSC Consultoria (contém um logotipo desenhado com as letras C, S e C)"
        >
      </router-link>

      <nav class="TheHeader-MenuWrapper">
        <menu-list
          :items="menuItems"
          :inline="true"
        />
      </nav>

      <div class="TheHeader-MenuButtonWrapper">
        <flat-button @click="openMenu()">
          <the-icon
            class="TheHeader-MenuButtonIcon"
            icon="menu"
          />
        </flat-button>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .TheHeader {
    width: 100%;
    background-color: $background-dark-color;
    border-bottom: 1px solid $background-dark-border;
    z-index: 1000;
    color: $foreground-light-color;

    @media screen and (min-width: $desktop-breakpoint) {
      flex-wrap: nowrap;
    }

    &-ContentWrapper {
      max-width: $max-content-width;
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto;
    }

    &-LogoWrapper {
      flex: 0 0 auto;
      order: 1;
      height: 60px;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: center;
      padding-left: 10px;

      text-decoration: none;
      border: none;
      color: $foreground-dark-color;

      &:hover {
        text-decoration: none;
      }
    }

    &-Logo {
      flex: 0 0 32px;
      height: 32px;
      width: auto;
    }

    &-MenuButtonIcon {
      padding: 0 5px;
    }

    &-MenuButtonWrapper {
      justify-self: end;
      margin-left: auto;
      flex: 0 0 auto;
      order: 3;
      padding: 8px 10px 0 0;

      @media screen and (min-width: $desktop-breakpoint) {
        display: none;
      }
    }

    &-MenuWrapper {
      flex: 0 0 100%;
      justify-self: end;
      order: 4;
      justify-content: center;
      align-items: center;
      padding: 10px;
      box-sizing: border-box;
      font-size: 14px;
      display: none;
      color: $foreground-light-color;

      @media screen and (min-width: $desktop-breakpoint) {
        display: flex;
        flex: 1 1 auto;
        order: 2;
      }
    }
  }
</style>

<script>
  import { MENU_HEADER } from "@/common/menus";
  import TheButton from "@/components/TheButton";
  import FlatButton from "@/components/FlatButton";
  import MenuList from "@/components/menu/MenuList";
  import TheIcon from "@/components/TheIcon";

  export default {
    components: {
      TheIcon,
      MenuList,
      TheButton,
      FlatButton,
    },

    data() {
      return {
        menuItems: MENU_HEADER,
      };
    },

    methods: {
      openMenu() {
        this.$emit("show-menu");
      },
    },
  };
</script>
